/*
 * @Author: liqiang70 liqiang70@58.com
 * @Date: 2025-05-14 16:05:40
 * @LastEditors: liqiang70 liqiang70@58.com
 * @LastEditTime: 2025-09-04 10:36:13
 * @Description: 
 */
import React from "react";
import Home from "./Home";
import Service from "./Service";
import AboutUs from "./AboutUs";

const routers = [
    {
        path: '/',
        component: Home,
    },
    {
        path: '/service',
        component: Service,
    },
    {
        path: '/aboutUs',
        component: AboutUs,
    },
]

export default routers;

